/**
 * The windows `/company/{symbol}/floorsheet/` takes as `?period=` (mm-be
 * `services/company/floorsheet.PERIODS`). Every one keys off the floorsheet's
 * own latest session, not the calendar: `today` is that session, `yesterday`
 * the one before it, `week` the last five.
 *
 * A module with no imports, because the Stock route's `validateSearch` parses
 * `?fp=` through it and a route loader's imports ship in the entry chunk.
 */
export const FLOORSHEET_PERIODS = ['today', 'yesterday', 'week'] as const

export type FloorsheetPeriod = (typeof FLOORSHEET_PERIODS)[number]

export const DEFAULT_FLOORSHEET_PERIOD: FloorsheetPeriod = 'today'

/** A URL value as a period, or null for anything mm-be would answer 400. */
export const parseFloorsheetPeriod = (value: unknown): FloorsheetPeriod | null =>
  (FLOORSHEET_PERIODS as readonly unknown[]).includes(value) ? (value as FloorsheetPeriod) : null
